/* eslint-disable import/prefer-default-export */
export const decodeHtmlStr = (str) => {
  // eslint-disable-next-line no-undef
  const parser = new DOMParser();
  return parser.parseFromString(`<!doctype html><body>${str}`, "text/html").body
    .textContent;
};
